/* eslint-disable no-nested-ternary */
import React, { useState, Fragment, useEffect } from "react";
import PropTypes from "prop-types";
import Button from "../../shared/button";
import styles from "./styles.css";
import { isValidRegistrationNo } from "../../../utils/helpers/is-valid-registration-no";
import InputRegNo from "../../shared/input-reg-no";
import InputRegNoPlateV2 from "../../shared/input-reg-no-plate-v2";
import { sendCustomGaEvents } from "../../../tracking";
import { getVehicleDetailsCta } from "./tracking";
import { Label } from "@cars24/turbo-web/lib/label";
import { Button as ButtonDls } from "@cars24/turbo-web/lib/button";
import { NUMBER } from "../../../constants/app-constants";
import { cancelIdleCallbackPolyfill, requestIdleCallbackPolyfill } from "../../../utils/helpers/request-idle-callback-polyfill";

const ERROR_TEXT = "Please enter valid registration number";

const RtoInfoRegNo = ({
    title = "Enter vehicle number",
    setUserCarRegistrationNOConnect,
    pageType,
    history,
    isRevamped = false
}) => {
    const [registrationNumber, setRegistrationNumber] = useState("");
    const [isError, setIsError] = useState(false);
    const [errorMessage, setErrorMessage] = useState(ERROR_TEXT);
    const [showRegNo, setShowRegNo] = useState(false);

    const registrationNumberValidator = (v) => isValidRegistrationNo(v.replace(/\s/g, ""));

    const onClickHandler = () => {
        if (isValidRegistrationNo(registrationNumber)) {
            setUserCarRegistrationNOConnect(registrationNumber);
            setIsError(false);
            sendCustomGaEvents({
                ...getVehicleDetailsCta,
                eventLabel: registrationNumber,
                eventCategory: `RTOPage_${pageType}`
            });
            history.push("/rto-details");
        } else {
            setErrorMessage(ERROR_TEXT);
            setIsError(true);
        }
    };

    const handleOnChange = (sanitizedValue) => {
        setRegistrationNumber(sanitizedValue);
    };

    useEffect(() => {
        const id = requestIdleCallbackPolyfill(() => {
            setShowRegNo(true);
        });

        return () => cancelIdleCallbackPolyfill(id);
    }, []);

    return (
        <Fragment>
            <div styleName={"styles.bannerWrapper"}>
                {
                    isRevamped ?
                        showRegNo ?
                            <Fragment>
                                <Label level={NUMBER.TWO} fontWeight="regular">{title}</Label>
                                <div styleName={"styles.regNoPlate"}>
                                    <InputRegNoPlateV2
                                        isError={isError}
                                        onChange={handleOnChange}
                                        customErrorMessage={errorMessage}
                                    />
                                </div>
                                <ButtonDls
                                    size="medium"
                                    variant="primary"
                                    label="Get vehicle details"
                                    onClick={onClickHandler}
                                />
                            </Fragment>
                            : <div styleName={"styles.shimmerWrapper"}>
                                <div className="shimmer">
                                    <Label level={NUMBER.TWO} fontWeight="regular">{title}</Label>
                                </div>
                                <div className="shimmer">
                                    <div styleName={"styles.regNoPlate"}>
                                        <InputRegNoPlateV2
                                            isError={isError}
                                            onChange={handleOnChange}
                                            customErrorMessage={errorMessage}
                                        />
                                    </div>
                                </div>
                                <div className="shimmer">
                                    <ButtonDls
                                        size="medium"
                                        variant="primary"
                                        label="Get vehicle details"
                                        onClick={onClickHandler}
                                    />
                                </div>
                            </div>
                        :
                        <div styleName={"styles.rtoControlFlow"}>
                            <h2>{title}</h2>
                            <div styleName={"styles.registrationWrapper"}>
                                <InputRegNo
                                    placeholder="DL 01 AB12XX"
                                    value={registrationNumber}
                                    isFromRegHomePage={true}
                                    isError={isError}
                                    onChange={handleOnChange}
                                    validator={registrationNumberValidator}
                                    customErrorText={errorMessage}
                                />
                                <Button
                                    text="GET VEHICLE DETAILS"
                                    onClick={onClickHandler}
                                />
                            </div>
                        </div>
                }
            </div>
        </Fragment>
    );
};

RtoInfoRegNo.propTypes = {
    pageType: PropTypes.string,
    title: PropTypes.string,
    setUserCarRegistrationNOConnect: PropTypes.func,
    history: PropTypes.object,
    isRevamped: PropTypes.bool
};

export default RtoInfoRegNo;
